<template>
  <div :class="{'HotelTeam':type==3}">
    <div class="order-team" v-if="type==2">
        <!--1.订单旅行社信息-->
            <div class="travel">
                <div class="travel-title">采购商信息</div>
                <div>
                    <div class="travel-desc">
                        <img src="/images/public/logo.png">
                        <div class="travel-name">
                            <p>{{orderDetail.travel_title}}</p>
                            <p>联系人: <span>{{orderDetail.send_name}}</span></p>
                            <!--成交时再显示手机号-->
                            <p v-if="orderDetail.deal_time>0||$GFUN.isInArray([2,99],storeInfo.type)">手机号: <span>{{orderDetail.send_mobile}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <!--用房信息-->
            <div class="housing">
                <div class="housing-title">用房信息</div>
                <ul class="housing-list">
                    <li><p>订单类型:</p><div>{{orderDetail.order_type==1?'住宿订单':'纯会议订单'}}</div></li>
                    <li><p>团  号:</p><div>{{orderDetail.title}}</div></li>
                    <li v-if="orderDetail.order_type==1"><p>入住人数:</p><div>{{orderDetail.num}}人</div></li>
                    <li v-if="orderDetail.order_type==1"><p>早餐类型:</p><div>{{orderDetail.breakfast}}</div></li>
                    <li v-if="orderDetail.eatery"><p>餐饮需求:</p><div>{{orderDetail.eatery | formatVar('eateryArr')}}</div></li> 
                    <!-- <li v-if="orderDetail.room_need_arr.num>0"><p>用房总数:</p><div>{{orderDetail.room_need_arr.num}}间</div></li>  -->
                    <li v-if="orderDetail.order_type==1"><p>入离日期:</p><div>{{orderDetail.date_in | formatTimestamp(2)}} ~ {{orderDetail.date_out | formatTimestamp(2)}} (共{{orderDetail.days}}晚)</div></li>
                    <li v-if="orderDetail.other"><p>会议设施:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.other,'meetRoomObj')" :key="item">{{item}}</span></div></li> 
                    <li v-if="storeInfo.type!=3"><p>星级需求:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.star,'HotelStar')" :key="item">{{item}}</span></div></li> 
                    <li v-if="storeInfo.type!=3"><p>用房区域:</p><div>{{orderDetail.province_name}}省&ensp;{{orderDetail.city_name}}市&ensp;{{orderDetail.district_name}}</div></li> 
                </ul>
            </div>
    </div>
    <!--2.成交酒店信息-->
    <template v-if="type==3">
        <div class="travelHotel min-height">
            <div class="travel-title">酒店信息</div>
            <div>
                <div class="travel-desc">
                    <img v-lazy="$GFUN.formatImgSrc(orderDetail.hotel_top_pic,64,64)" class="hotel-img cursor-pointer"/>
                    <div class="travel-name">
                        <p class="title">
                            {{orderDetail.hotel_title}}
                            <img class="ml-1" v-lazy="'/images/zfxj/icon_'+orderDetail.hotel_state_star+'.png'" :key="orderDetail.hotel_state_star" height="18px" v-if="orderDetail.hotel_state_star>0"/>
                            <img class="ml-1" v-lazy="'/images/xj/icon_'+orderDetail.hotel_star+'.png'" :key="orderDetail.hotel_star" height="18px" v-else/>
                        </p>
                        <p>联系人: <span>{{orderDetail.offer_name}}</span></p>
                        <p>手机号: <span>{{orderDetail.offer_mobile}}</span></p>
                    </div>
                </div>
            </div>
            <div class="frontDeskPhone">前台电话：{{orderDetail.hotel_tel}}</div>
            <div class="frontDeskPhone none">报价说明：{{orderDetail.offer_remark||'无'}}</div>
        </div>
        <!--入住名单信息-->
        <OrderCheckList :orderDetail="orderDetail" @getorderDetail="getorderDetail"></OrderCheckList>
    </template>
  </div>
</template>

<script>
import OrderCheckList from './OrderCheckList' //核房人、支付人、入住名单
import { mapGetters,} from 'vuex'
export default {
  name: '',
  components: {
    OrderCheckList
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['storeInfo']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    //星级需求
    starns(e,type){
        let result
        if(!e)return['无']
        if(!e.toString().includes(',')){
          result=new Array(e)
        }else{
          if(!Array.isArray(e)){
            result=e.split(',')
          }
        }
        let n=this.$options.filters['formatStars'](result,type);
        return n
    },
    //获取订单详情
    getorderDetail(){
        console.log('已执行')
      this.$emit('getorderDetail');
    }
  }
};
</script>

<style lang="scss" scoped>
    .order-team{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .travel{
        width: 25%;
        padding: 16px 2%;
        background-color: #fff;
        border-radius: 6px;
    }
    .HotelTeam{
        width: 29%;
    }
    .travelHotel{
        width: 86%;
        padding: 16px 7%;
        background-color: #fff;
         border-radius: 6px;
    }
    .min-height{
        height: max-content;
        min-height: 190px;
    }
    .travel-title,.housing-title{
        font-weight: bold;
        font-size: 16px;
    }
    .travel-desc{
        margin-top: 16px;
        display: flex;
        >img{
            width: 80px;
        }
        .travel-name{
            margin-left: 16px;
            height: 80px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            p{
                margin-top: 6px;

            }
            p:nth-child(1){
                font-size: 16px;
                font-weight: bold;
                margin-top:0;
            }
        }
    }
    .housing{
        width: 64%;
        padding: 16px 2%;
        background-color: #fff;
        border-radius: 6px;
    }
    .housing-list{
        display: flex;
        flex-wrap: wrap;
        li{
            width: 49%;
            margin-top: 12px;
            p{
                width: 80px;
                color: #999;
                float: left;
            }
            div{
                display: inline-block;
                width: 78%;
            }
        }
    }
    .title{

        font-weight: bold;  
        font-size: 16px;
        display: inline-flex;
        align-items: center; /* 图片垂直居中 */
    }
    .frontDeskPhone{
        margin-top: 8px;
        border-top: 1px #eee solid;
        padding-top: 8px;
        font-size: 12px;
        color: #666;
    }
    .none{
        border-top: none;
        margin-top: 4px;
        padding-top: 4px;
    }
</style>
